import { render, staticRenderFns } from "./MovementForm.vue?vue&type=template&id=5196fd20&scoped=true"
import script from "./MovementForm.vue?vue&type=script&lang=ts"
export * from "./MovementForm.vue?vue&type=script&lang=ts"
import style0 from "./MovementForm.vue?vue&type=style&index=0&id=5196fd20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5196fd20",
  null
  
)

export default component.exports